import type { FeedFormat, FeedSort, Platform, SourcePostsParams } from '../api/types'
import { sortsFor } from './feedFormat.ts'
import { metricView } from './measurement.ts'

/** Архив автора: все сохранённые даты и посты, сначала новые публикации. */
export function sourceContentFilters(params: URLSearchParams, platform: Platform) {
  const format: FeedFormat = platform === 'instagram' && (params.get('format') ?? params.get('f')) !== 'text' ? 'video' : 'text'
  const sorts = sortsFor(format, platform)
  const rawSort = params.get('s') as FeedSort | null
  const sort: FeedSort = rawSort && sorts.includes(rawSort) ? rawSort : 'new'
  const rawDays = params.get('period_days') ?? params.get('d')
  const parsedDays = Number(rawDays)
  const unsupportedPeriod = params.has('date_from') || params.has('date_to') || (Number.isInteger(parsedDays) && parsedDays > 365)
  const days = !unsupportedPeriod && rawDays && Number.isInteger(parsedDays) && parsedDays >= 1 && parsedDays <= 365 ? parsedDays : undefined
  const query: SourcePostsParams = { format, days, sort, only_outliers: params.get('outliers') === '1', limit: 30,
    ...(metricView(params) ? { metric_view: metricView(params) } : {}) }
  return { format, sorts, query, unsupportedPeriod }
}
